import React from 'react'
import Footer from '../components/common/Footer'

const FooterLayout = ({ children }) => (
  <div className="main">
    <article id="content" className="content">
      {children}
    </article>
    <Footer />
  </div>
)

export default FooterLayout
